import { render, staticRenderFns } from "./LegalMideaPayDialog.vue?vue&type=template&id=96c8a422&"
import script from "./LegalMideaPayDialog.vue?vue&type=script&lang=js&"
export * from "./LegalMideaPayDialog.vue?vue&type=script&lang=js&"
import style0 from "./LegalMideaPayDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports